<mat-toolbar color="primary">
  <span>ITF Group</span>
</mat-toolbar>
<div class="main">
  <router-outlet></router-outlet>
</div>

